<div *ngIf="title" [style.color]="textColor" [style.fontSize.px]="title.size" [style.textAlign]="title.align" class="title">{{title.text}}</div>
<div *ngFor="let kpi of kpis" [ngClass]="kpis.length > 1 ? 'multi' : ''" class="ui statistic">
  <i *ngIf="icons" [ngClass]="icons[kpi.name] || 'circle'" [style.color]="icons[kpi.name] ? metricColor : 'transparent'" class="icon"></i>
  <div class="content">
    <div [style.color]="metricColor" [style.fontSize.px]="kpiMetric.size" [style.textAlign]="kpiMetric.align" class="value">
      {{kpi.value | format:getKpiFormat(kpi)}}
      <benchmark-result
        *ngIf="kpis.length > 1"
        [benchmark]="benchmarkPages &&
          benchmarkPages[0] &&
          benchmarkPages[0][0] &&
          benchmarkPages[0][0][kpi.name]"
        [benchmarkClassName]="benchmarkPages &&
          benchmarkPages[0] &&
          benchmarkPages[0][0] &&
          benchmarkPages[0][0][kpi.name]
            ? getBenchmarkClassNames(getComparison(kpi), benchmarkPages[0][0][kpi.name])
            : ''"
        [timePeriod]="compareTo"
        [loadingBenchmarks]="loadingBenchmarks">
      </benchmark-result>
    </div>
    <div *ngIf="metricLabel.enabled" [style.fontSize.px]="metricLabel.size" [style.textAlign]="metricLabel.align" [style.color]="textColor" class="label">{{kpi.displayName}}</div>
    <div *ngIf="kpis.length === 1" [style.textAlign]="metricLabel.align">
      <benchmark-result
        [style.fontSize.px]="metricLabel.size"
        [benchmark]="benchmarkPages &&
          benchmarkPages[0] &&
          benchmarkPages[0][0] &&
          benchmarkPages[0][0][kpi.name]"
        [benchmarkClassName]="benchmarkPages &&
          benchmarkPages[0] &&
          benchmarkPages[0][0] &&
          benchmarkPages[0][0][kpi.name]
            ? getBenchmarkClassNames(getComparison(kpi), benchmarkPages[0][0][kpi.name])
            : ''"
        [timePeriod]="compareTo"
        [loadingBenchmarks]="loadingBenchmarks">
      </benchmark-result>
    </div>
  </div>
</div>
<div *ngIf="!!footer" class="kpi-footer">
  <span *ngIf="footer.datasetInfo">{{footerData.datasetInfo}}</span>
  <span *ngIf="footer.dateRange">{{footerData.dateRange}}</span>
</div>